import { atom } from "recoil"

const OrganisationUnitsState = atom<any>({
    key: 'ous',
    default: null
})

export {OrganisationUnitsState}